// extracted by mini-css-extract-plugin
export default {"rowWrapper":"domestic-quote-prices_rowWrapper__UDgY4"};